<template>
  <div class="text-center">
    <v-dialog persistent v-model="openCreateForm" width="700">
      <v-card>
        <loader v-if="showLoader"></loader>
        <v-card-title class="headline grey lighten-2">
          {{ titleType }}
        </v-card-title>

        <v-card-text>
          <div>
            <v-form
              ref="createForm"
              v-model="valid"
              lazy-validation
              class="input-container"
            >
              <v-text-field
                v-model="formData.email"
                :rules="emailRules"
                label="Enter Email"
                required
                name="userEmail"
                id="userEmail"
              ></v-text-field>

              <v-text-field
                v-model="formData.mobile"
                :rules="mobileRules"
                label="Enter Mobile"
                required
                name="userMobile"
                id="userMobile"
              ></v-text-field>

              <v-text-field
                v-model="formData.firstName"
                :rules="firstNameRules"
                label="Enter First Name"
                name="firstName"
                id="firstName"
                required
              ></v-text-field>

              <v-text-field
                v-model="formData.lastName"
                :rules="lastNameRules"
                label="Enter Last Name"
                name="lastName"
                id="lastName"
                required
              ></v-text-field>

              <v-select
                v-model="formData.role"
                @change="changeRole(formData.role)"
                :items="roleList"
                item-text="name"
                item-value="_id"
                :rules="[(v) => !!v || 'Item is required']"
                label="Select Role"
                required
                name="userCategory"
                id="userCategory"
                :loading="roleLoader"
              ></v-select>

              <div class="d-flex">
                <div class="ml-auto">
                  <v-btn class color="success" text @click="getShowPermission()"
                    >+ Add more permission</v-btn
                  >
                </div>
              </div>

              <!-- permission check box -->
              <div v-if="showPermission">
                <div
                  class="col-sm-12 border-bottom"
                  v-for="(key, index) in permissionResponseData"
                  :key="index"
                >
                  <h6>{{ showingName(index) }}</h6>

                  <label
                    class="container-check mr-3"
                    v-for="(item, j) in key"
                    :key="j"
                  >
                    <input
                      :checked="editRolePermissions.includes(item)"
                      type="checkbox"
                      @change="selectPermission(item)"
                      class="mr-1"
                    />
                    {{ showingName(item) }}
                    <span class="checkmarked"></span>
                  </label>
                </div>
              </div>

              <div class="text-right mt-5">
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="submitForm()"
                  >Submit</v-btn
                >
                <v-btn color="error" class="mr-4" @click="closeModal()"
                  >Cancel</v-btn
                >
              </div>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import loader from "@/components/loader.vue";
export default {
  components: {
    loader,
  },
  props: ["openCreateForm", "adminUserID", "permissionResponseData"],
  data() {
    return {
      roleLoader: false,
      showLoader: false,
      roleList: [],
      valid: true,
      titleType: "",
      userRoleId: "",
      firstNameRules: [(v) => !!v || "First Name is required"],

      lastNameRules: [(v) => !!v || "Last Name is required"],

      mobileRules: [
        (v) => !!v || "Mobile no is required",
        (v) => (v && v.length <= 10) || "NO be less than 10 ",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      items: ["Query", "Suggestion", "Feedback", "Complaint"],

      formData: {
        email: "",
        mobile: "",
        firstName: "",
        lastName: "",
        role: "",
      },
      editRolePermissions: [],
      selectedRolePermissions: [],
      emailAlreadyPresent: false,
      showPermission: false,
      selectedRoleData: {},
      roleChange: false,
    };
  },

  mounted() {
    this.getRoles();
  },

  methods: {
    // create or edit modal check event
    currentType() {
      if (this.adminUserID === "create") {
        this.titleType = "Create Admin User";
      } else {
        this.titleType = "Edit Admin User";
        this.showLoader = true;
        let url = `${config.BASE_URL}api/v2/admin/users/${this.adminUserID}`;
        this.$http.get(url).then((response) => {
          if (response.body.status) {
            this.showLoader = false;
            this.formData.email = response.body.data.email;
            this.formData.mobile = response.body.data.mobile;
            this.formData.firstName = response.body.data.first_name;
            this.formData.lastName = response.body.data.last_name;

            // this code for v-model value already selected
            this.userRoleId = response.body.data.user_role._id;
            this.editRolePermissions = response.body.data.permissions;
            this.selectedRolePermissions = response.body.data.permissions;
            let selected = this.roleList.filter(
              (el) => el._id == this.userRoleId
            )[0];
            this.formData.role = selected._id;
          }
        });
      }
    },

    // close modal event
    closeModal() {
      this.$emit("close");
    },

    // permission button hide and show event
    getShowPermission() {
      this.showPermission = !this.showPermission;
    },

    showingName(string) {
      let key = _.startCase(string);
      return key;
    },

    // submit event for edit and create functionality
    submitForm() {
      if (this.$refs.createForm.validate()) {
        this.showLoader = true;
        if (this.adminUserID === "create") {
          let obj = {
            email: this.formData.email,
            mobile: this.formData.mobile,
            first_name: this.formData.firstName,
            last_name: this.formData.lastName,
            user_role: this.formData.role,
            permissions: this.selectedRolePermissions,
          };
          let url = `${config.BASE_URL}api/v2/admin/users`;
          this.$http.post(url, obj).then((response) => {
            if (response.body.status) {
              this.showLoader = false;
              this.$refs.createForm.reset();
              Swal.fire({
                title: `Permissions created successfully`,
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok",
              });
              this.$emit("close");
              this.$emit("getAdminUserApiCall");
            } else {
              this.showLoader = false;
            }
          });
        } else {
          let obj = {
            email: this.formData.email,
            mobile: this.formData.mobile,
            first_name: this.formData.firstName,
            last_name: this.formData.lastName,
            user_role: this.formData.role,
            permissions: this.selectedRolePermissions,
          };
          let url = `${config.BASE_URL}api/v2/admin/users/${this.adminUserID}`;
          this.$http.put(url, obj).then((response) => {
            if (response.body.status) {
              this.$refs.createForm.reset();
              Swal.fire({
                title: `Permissions edited successfully`,
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok",
              });
              this.$emit("close");
              this.$emit("getAdminUserApiCall");
            }
          });
        }
      }
    },

    getRoles() {
      this.roleLoader = true;
      let url = `${config.BASE_URL}api/v2/admin/roles`;
      this.$http.get(url, { params: { is_active: true } }).then((response) => {
        if (response.body.status) {
          this.roleList = response.body.data;
          this.currentType();
          this.roleLoader = false;
        } else {
          this.roleLoader = false;
          this.roleList = [];
        }
      });
    },

    selectPermission(item) {
      if (this.selectedRolePermissions.length > 0) {
        let newRole = this.selectedRolePermissions.indexOf(item);
        if (newRole != -1) {
          this.selectedRolePermissions.splice(newRole, 1);
        } else {
          this.selectedRolePermissions.push(item);
        }
      } else {
        this.selectedRolePermissions.push(item);
      }
    },
    changeRole(roleId) {
      // this.roleChange = true;
      this.selectedRoleData = this.roleList.filter(
        (el) => el._id === roleId
      )[0];
      this.editRolePermissions = this.selectedRoleData.permissions;
      this.selectedRolePermissions = this.selectedRoleData.permissions;
    },
  },
};
</script>
